<template>
  <section class="form-list">
    <el-form
      class="form form-large"
      ref="form"
      :rules="rules"
      :model="course"
      label-position="right"
      label-width="130px"
    >
      <el-form-item v-if="isAdministrator" label="所属门店" prop="store_id">
        <v-select-store v-model="course.store_id" @change="handleStoreChange" width="100%"/>
      </el-form-item>
      <el-form-item label="课程老师" prop="course_teacher_ids">
        <v-select-teacher
          class="w100"
          :list="teachers"
          v-model="course.course_teacher_ids"
          :multiple="true"
          :store-id="course.store_id"
          :remote="true"
          @change="handleTeacherChange"
        />
        <div v-for="teacher in course.teachers" :key="`teacherSub${teacher.id}`" class="teacher-item">
          <v-avatar-nickname :value="teacher.avatar" :nickname="teacher.nickname"/>
          <v-select-sub-teacher
            class="course-state-select"
            v-model="teacher.sub_teacher_id"
            :list="teachers"
            :disabledId="course.course_teacher_ids"
            :clearable="true"
            :remote="true"
            :store-id="course.store_id"
            @change="t => teacher.subTeacher = t"
            placeholder="若请假，请选择代课老师"
          />
        </div>
      </el-form-item>
      <el-form-item label="课程类型" prop="card_type_id">
        <v-select-card-type-id
          class="w100"
          v-model="course.card_type_id"
          :store-id="course.store_id"
          @change="cardTypeId => isNotPersonalCourse = cardTypeId !== cardTypes.personal.value"
        />
      </el-form-item>

      <template v-if="isNotPersonalCourse">
        <el-form-item label="舞蹈风格" prop="course_style_id">
          <v-select-course-style
            class="w100"
            v-model="course.course_style_id"
            @change="handleCourseStyleChange"
          />
        </el-form-item>
        <el-form-item label="课程难度" prop="course_difficulty_id">
          <v-select-course-difficulty
            class="w100"
            v-model="course.course_difficulty_id"
            @change="handleCourseDifficultyChange"
          />
        </el-form-item>
        <el-form-item label="课程年龄" prop="course_age_id">
          <v-select-course-age
            class="w100"
            v-model="course.course_age_id"
            @change="handleCourseAgeChange"
          />
        </el-form-item>
        <div class="course-media-title">课程展示素材</div>
        <el-form-item label="展示类型">
          <el-radio-group v-model="mediaType" @change="handleMediaTypeChange">
            <el-radio label="trailer">课程预告片</el-radio>
            <el-radio label="cover">封面图</el-radio>
            <el-radio label="course_video">课程介绍视频</el-radio>
          </el-radio-group>
          <div class="course-media-tip">请选择小程序端课程详情页顶部展示的素材类型（三选一），仅当前选择的这一种会展示在小程序。</div>
        </el-form-item>
        <el-form-item v-if="mediaType === 'cover'" label="课程封面" prop="course_cover_id">
          <v-select-course-cover class="w100" v-model="course.course_cover_id"/>
        </el-form-item>
        <el-form-item v-else-if="mediaType === 'course_video'" label="课程介绍视频" prop="course_video_id" required>
          <v-select-course-video class="w100" v-model="course.course_video_id"/>
        </el-form-item>
        <template v-else-if="mediaType === 'trailer'">
          <el-form-item label="课程预告片名称">
            <el-input v-model="course.trailer_video.media_name" maxlength="64" clearable placeholder="请输入课程预告片名称"/>
          </el-form-item>
          <v-video-upload
            label="课程预告片文件"
            prefix="course-trailer"
            prop-name="trailer_raw_src"
            v-model="course.trailer_video.raw_src"
            :src="course.trailer_video.src"
            :required="true"
            @srcChange="src => course.trailer_video.src = src"
            @fileChange="file => trailerFile = file"
          />
          <v-video-cover
            v-model="course.trailer_video.cover"
            :file="trailerFile"
            label="课程预告片封面"
            prefix="course-trailer-cover"
            prop-name="trailer_cover"
          />
        </template>

          <div class="course-media-title">课堂视频（选填，课程结束后上传）</div>
          <el-form-item label="课堂视频名称">
            <el-input v-model="course.classroom_video.media_name" maxlength="64" clearable placeholder="请输入课堂视频名称"/>
          </el-form-item>
          <v-image-upload
            v-model="course.classroom_video.cover"
            label="课堂视频封面"
            prefix="course-classroom-cover"
            ratio="16:9"
            prop-name="classroom_cover"
          />
          <v-video-upload
            label="课堂视频文件"
            prefix="course-classroom"
            prop-name="classroom_raw_src"
            v-model="course.classroom_video.raw_src"
            :src="course.classroom_video.src"
            @srcChange="src => course.classroom_video.src = src"
          />

        <el-form-item label="课程标签" prop="course_tag_ids">
          <v-select-course-tag class="w100" v-model="course.course_tag_ids" @itemChange="handleCourseTagChange"/>
        </el-form-item>
        <el-form-item label="课程白名单" prop="course_whitelist_id">
          <v-select-course-whitelist class="w100" v-model="course.course_whitelist_id" :clearable="true"/>
        </el-form-item>
        <el-form-item label="课程专栏" prop="course_column_id">
          <v-select-course-column class="w100" v-model="course.course_column_id" @itemChange="handleCourseColumnChange"/>
        </el-form-item>
        <el-form-item label="注意事项" prop="course_tip_id">
          <v-select-course-tip class="w100" v-model="course.course_tip_id" :disabled="!!course.course_column_id && !course.is_reservable_solo"/>
        </el-form-item>
      </template>

      <el-form-item label="课程人数" prop="student_number">
        <v-input-number
          v-model="course.student_number"
          type="unsignedTinyInt"
          :is-show-suffix="true"
          suffix-name="人"
          :disabled="!!course.course_column_id && !course.is_reservable_solo"
          placeholder="请输入课程人数"
        />
      </el-form-item>

      <el-form-item label="开放预约天数" prop="reserve_day">
        <v-input-number
          v-model="course.reserve_day"
          type="unsignedSmallInt"
          :is-show-suffix="true"
          suffix-name="天"
          :disabled="!!course.course_column_id && !course.is_reservable_solo"
          placeholder="请输入天数"
        />

        <el-alert
          title="默认提前 3 天开放预约，周一中午 12 点可预约周四课程，设置为 0 则仅限当天可约。"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="禁止取消预约" prop="student_number">
        <v-input-number
          v-model="course.cancel_hour"
          type="unsignedSmallInt"
          :is-show-suffix="true"
          suffix-name="小时内"
          :disabled="!!course.course_column_id && !course.is_reservable_solo"
          :min="1"
          placeholder="请输入小时数"
        />
      </el-form-item>

      <el-form-item label="预约方式">
        <el-radio-group
          v-model="course.reserve_type"
          :disabled="!!course.course_column_id && !course.is_reservable_solo"
          @change="handleReserveTypeChange"
        >
          <el-radio label="card">课卡预约</el-radio>
          <el-radio label="free">免费预约</el-radio>
          <el-radio label="show_free">不鸽费预约</el-radio>
        </el-radio-group>

        <div v-if="isCardReserve" class="reserve-mode-box">
          <i class="el-icon-info reserve-mode-icon"/>
          <div>
            <div class="reserve-mode-title">课卡预约：学员用课卡 / 课次券预约，或微信支付</div>
            <div class="reserve-mode-line">按下面填写的「扣卡次数」「通卡扣卡天数」扣卡；开通微信支付后，没有课卡的学员也能付费报名。</div>
          </div>
        </div>
        <div v-else-if="course.reserve_type === 'free'" class="reserve-mode-box is-warning">
          <i class="el-icon-warning-outline reserve-mode-icon"/>
          <div>
            <div class="reserve-mode-title">免费预约：所有学员都能免费报名，不扣课卡、不收钱</div>
            <div class="reserve-mode-line">学员点【免费预约】就能占座，不扣次卡 / 通卡 / 课次券，后台也不会收到任何钱，下面与扣卡、收费有关的选项都不再显示。</div>
            <div class="reserve-mode-line is-danger">适合门店临时公开课、体验活动。常规课选这项，所有学员都会免费上课、课卡一次也不扣。</div>
          </div>
        </div>
        <div v-else class="reserve-mode-box is-warning">
          <i class="el-icon-warning-outline reserve-mode-icon"/>
          <div>
            <div class="reserve-mode-title">不鸽费预约：上课免费，但学员要先付押金锁座</div>
            <div class="reserve-mode-line">押金 = 课程价格（有通卡价格的学员按通卡价格）；学员端只显示【微信支付预约】，课卡与课次券都用不了。</div>
            <div class="reserve-mode-line is-danger">押金不是课时费：学员签到后要在后台「预约名单」里发起退款、原路退回；爽约是否退按门店规则处理。</div>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="isCardReserve" label="扣卡次数">
        <v-input-money
          class="w100"
          :min="0"
          :max="999"
          v-model="course.decrement_number"
          placeholder="请输入课程扣卡次数"
          :is-show-suffix="true"
          suffix-name="次"
          :disabled="!!course.course_column_id && !course.is_reservable_solo"
        />
      </el-form-item>
      <el-form-item v-if="isCardReserve" label="通卡扣卡天数">
        <v-input-money
          class="w100"
          :min="0"
          :max="36600"
          v-model="course.decrement_days"
          placeholder="请输入通卡预约所扣天数"
          :is-show-suffix="true"
          suffix-name="天"
          :disabled="!!course.course_column_id && !course.is_reservable_solo"
        />
      </el-form-item>
      <el-form-item label="课程日期" prop="date">
        <el-date-picker
          class="w100"
          v-model="course.date"
          :picker-options="pickerOptionsOfAfterSystemStartDay"
          type="date"
          value-format="yyyy-MM-dd"
          align="right"
          placeholder="请选择所属日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="课程时间">
        <el-col :span="11">
          <el-form-item prop="start_time">
            <el-time-picker
              v-model="course.start_time"
              arrow-control
              :clearable="false"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="开始时间"
              style="width: 100%"
              @change="handleStartTimeChanged"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" class="flex-center">至</el-col>
        <el-col :span="11">
          <el-form-item prop="end_time">
            <el-time-picker
              v-model="course.end_time"
              arrow-control
              :clearable="false"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="结束时间"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <el-alert
          v-if="isTomorrowEndTime"
          title="当前结束时间视为明日时间"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <template v-if="!course.course_column_id || course.is_reservable_solo">
        <el-form-item label="可任意时间预约">
          <el-switch v-model="course.is_advance_reserve" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，学员根据开放预约天数进行预约"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item label="需要身份证号码">
          <el-switch v-model="course.is_need_id" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，学员预约无需身份证号码"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item v-if="isCardReserve" label="禁止通卡预约">
          <el-switch v-model="course.is_disable_term" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后可禁止学员使用通卡预约"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item v-if="isCardReserve" label="禁止次卡预约">
          <el-switch v-model="course.is_disable_number" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后可禁止学员使用次卡预约"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item v-if="isCardReserve" label="禁止课次券预约">
          <el-switch v-model="course.is_disable_ticket" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后可禁止学员使用课次券预约"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item label="禁止取消预约">
          <el-switch v-model="course.is_disable_cancel" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，学员可在课程开始 6 小时前取消预约"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item label="禁止排队">
          <el-switch v-model="course.is_disable_queue" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后可禁止学员在课程约满后加入排队"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item v-if="isCardReserve" label="可微信支付预约">
          <el-switch v-model="course.is_we_chat_pay" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后可使用微信支付进行预约课程"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item v-if="course.is_we_chat_pay" label="课程价格" prop="price">
          <v-input-money
            class="w100"
            placeholder="请输入课程价格"
            v-model="course.price"
            :is-show-suffix="true"
            @input="handlePriceChange"
            :min="199"
            :max="9999.99"
          />
          <el-alert
            title="目前单节课默认最低 199 元，可设置 ≥ 199 的单节课价格"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item v-if="course.is_we_chat_pay && course.is_disable_term" label="通卡价格" prop="term_price">
          <v-input-money
            class="w100"
            placeholder="请输入通卡会员购买课程的价格"
            v-model="course.term_price"
            :is-show-suffix="true"
            :min="199"
            :max="course.price"
          />
          <el-alert
            title="目前单节课默认最低 199 元，可设置 ≥ 199 的单节课价格"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item label="不在课程列表展示">
          <el-switch v-model="course.is_hide_in_list" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后，小程序的首页课表、门店课表、老师课表均不展示"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item label="仅工作人员可分享">
          <el-switch v-model="course.is_staff_share_only" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后，小程序的分享功能将仅限后台系统录入的工作人员使用"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>
      </template>

      <el-form-item label="课程名称后缀">
        <el-input v-model="course.tag_name" maxlength="8" show-word-limit clearable/>

        <el-alert
          title="小程序将在课程名称的右边显示此后缀，例如：双杀课"
          type="info"
          show-icon
          :closable="false"
          class="form-input-tip"
        />
      </el-form-item>

      <el-form-item label="不计入排名统计">
        <el-switch v-model="course.is_disable_rank" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，课程人数默认计入老师月度排名统计中"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <v-image-upload
        v-model="course.teacher_avatar"
        label="课程列表页封面"
        prefix="course"
        ratio="1:1"
        placeholder="小程序将在课程列表页显示此封面，代替老师头像。"
      />
      <v-image-upload
        v-model="course.tag_img"
        label="标签图片"
        prefix="course_tag"
        ratio="41:10"
        placeholder="小程序将在课程名称的右边显示此图片，代替标签文字。"
      />

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.cardList.back">取消</el-button>
      </el-form-item>

    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { cardTypes } from "@/enums/cardTypes";
import { courseMediaTypes } from "@/enums/courseMediaTypes";
import { show, store } from '@/api/course';
import { getMilliseconds, pickerOptionsOfAfterSystemStartDay } from '@/utils/formats';
import { toCent, toSecond, toYuan } from "@/utils/number";
import { index as getTeachers } from "@/api/teacher";

const validateStudentNumber = (rule, value, callback) => {
  callback(value ? undefined : new Error('请输入课程人数'));
};

// 课卡预约的扣卡次数不能为 0：0 代表免费预约，请在上方「预约方式」里选对应模式
const validateDecrementNumber = (rule, value, callback) => {
  callback(value >= 0.01 ? undefined : new Error('请输入扣卡次数，最少 0.01 次；免费预约请把「预约方式」改为免费预约'));
};

// 微信支付价 / 不鸽费押金，接口要求 199 ~ 9999.99 元：前端同步卡住，别等提交后被接口拦下
const validatePrice = (rule, value, callback) => {
  const price = Number(value);
  callback(price >= 199 && price <= 9999.99 ? undefined : new Error('请输入 199 ~ 9999.99 元之间的金额'));
};

export default {
  name: RouteConfig.courseAdd.name,
  data: () => ({
    RouteConfig,
    pickerOptionsOfAfterSystemStartDay,
    cardTypes,
    isSaving: false,
    isNotPersonalCourse: true,
    mediaType: 'trailer',
    lastMediaType: 'trailer',
    trailerFile: null,
    teachers: [],
    course: {
      store_id: 0,
      date: '',
      start_time: '13:00',
      end_time: '14:00',
      course_age_id: '',
      course_style_id: '',
      course_difficulty_id: '',
      card_type_id: '',
      course_column_id: 0,
      course_cover_id: 1,
      course_video_id: 0,
      course_media: [],
      trailer_video: {
        media_name: '',
        cover: '',
        raw_src: '',
        src: '',
        state: 1,
      },
      classroom_video: {
        media_name: '',
        cover: '',
        raw_src: '',
        src: '',
        state: 1,
      },
      course_tip_id: 1,
      student_number: 30,
      course_tag_ids: [],
      course_whitelist_id: 0,
      course_teacher_ids: [],
      course_name: '',
      reserve_type: 'card',
      decrement_number: 1,
      decrement_days: 0,
      reserve_day: 3,
      cancel_hour: 6,
      teachers: [],
      style_name: '',
      difficulty_name: '',
      is_advance_reserve: 0,
      is_disable_cancel: 0,
      is_we_chat_pay: 0,
      price: 200,
      term_price: 200,
      teacher_avatar: '',
      tag_img: '',
      tag_name: '',
      is_disable_rank: 0,
      is_disable_term: 0,
      is_disable_queue: 0,
      is_disable_number: 0,
      is_disable_ticket: 0,
      is_need_id: 0,
      is_show_free: 0,
      is_hide_in_list: 0,
      is_staff_share_only: 0,
      is_reservable_solo: 0,
    },
    rules: {
      store_id: [{ required: true, message: '请选择门店', trigger: 'change' }],
      course_teacher_ids: [{ required: true, message: '请选择老师', trigger: 'change' }],
      course_style_id: [{ required: true, message: '请选择舞蹈风格', trigger: 'change' }],
      course_difficulty_id: [{ required: true, message: '请选择课程难度', trigger: 'change' }],
      course_age_id: [{ required: true, message: '请选择课程年龄', trigger: 'change' }],
      card_type_id: [{ required: true, message: '请选择课程类型', trigger: 'change' }],
      course_cover_id: [{ required: true, message: '请选择课程封面', trigger: 'change' }],
      course_video_id: [{ required: true, message: '请选择课程介绍视频', trigger: 'change' }],
      course_tip_id: [{ required: true, message: '请选择课程注意事项', trigger: 'change' }],
      student_number: [{ required: true, message: '请输入课程人数', validator: validateStudentNumber, trigger: 'change' }],
      date: [{ required: true, message: '请选择课程开始日期', trigger: 'change' }],
      decrement_number: [{ required: true, validator: validateDecrementNumber, trigger: 'change' }],
      price: [{ required: true, validator: validatePrice, trigger: 'change' }],
      term_price: [{ required: true, validator: validatePrice, trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'userStoreId',
    ]),
    id() {
      return +this.$route.query.id || 0;
    },
    isTomorrowEndTime() {
      const { start_time, end_time } = this.course;
      return start_time >= end_time;
    },
    // 私教课不展示「课程展示素材」区块，mediaType 无入口修改，
    // 这里固定按封面图处理，避免默认选中预告片时误触发预告片必填校验
    activeMediaType() {
      return this.isNotPersonalCourse ? this.mediaType : 'cover';
    },
    // 课卡预约才需要扣次/扣天/三个禁用开关/微信支付这些配置，免费与不鸽费预约一律隐藏
    isCardReserve() {
      return this.course.reserve_type === 'card';
    },
  },
  methods: {
    handleCourseColumnChange(courseColumn) {
      Object.assign(this.course, {
        store_id: courseColumn.store_id,
        course_type_id: courseColumn.course_type_id,
        course_tip_id: courseColumn.course_tip_id,
        decrement_number: toYuan(courseColumn.decrement_number),
        decrement_days: toYuan(courseColumn.decrement_days),
        student_number: courseColumn.student_number,
        is_disable_number: courseColumn.is_disable_number,
        is_disable_ticket: courseColumn.is_disable_ticket,
        is_disable_term: courseColumn.is_disable_term,
        is_disable_cancel: courseColumn.is_disable_cancel,
        is_disable_queue: courseColumn.is_disable_queue,
        is_we_chat_pay: courseColumn.is_we_chat_pay,
        price: toYuan(courseColumn.price),
        term_price: toYuan(courseColumn.term_price),
        is_reservable_solo: courseColumn.is_reservable_solo,
        is_hide_in_list: courseColumn.is_hide_in_list,
        is_staff_share_only: courseColumn.is_staff_share_only,
      });
      this.syncReserveType();
    },
    handleCourseTagChange(courseTag) {
      Object.assign(this.course, {
        is_hide_in_list: courseTag.is_hide_in_list,
        is_staff_share_only: courseTag.is_staff_share_only,
      });
    },
    handleStoreChange(storeId) {
      this.course.course_teacher_ids = [];
      this.course.teachers = [];
      this.course.store_id = storeId;

      this.getTeachers();
    },
    handleTeacherChange(teachers) {
      this.course.teachers = teachers;
    },
    handleCourseStyleChange(style_name) {
      this.course.style_name = style_name;
    },
    handleCourseDifficultyChange(difficulty_name) {
      this.course.difficulty_name = difficulty_name;
    },
    handleCourseAgeChange(age_name) {
      this.course.age_name = age_name;
    },
    handleStartTimeChanged(v) {
      if (this.course.end_time > v || !v) return;

      const startTimes = v.split(':');
      let maxTime = `${+startTimes[0] + 1}:${startTimes[1]}`;
      if (maxTime > '23:59') maxTime = '23:59';
      this.course.end_time = maxTime;
    },
    handlePriceChange(price) {
      this.course.term_price = price;
    },
    // 预约方式由数据反推（复制模板 / 选择专栏后都走这里）：不鸽费 > 免费（扣次为 0）> 课卡
    syncReserveType() {
      const { is_show_free, decrement_number } = this.course;
      this.course.reserve_type = is_show_free ? 'show_free' : (decrement_number ? 'card' : 'free');
      // 老数据可能挂在不鸽费上却没开微信支付：按该模式的规则补齐，否则价格字段是隐藏的、保存必然报错
      if (this.course.reserve_type === 'show_free' && !this.course.is_we_chat_pay) {
        this.handleReserveTypeChange('show_free');
      }
    },
    handleReserveTypeChange(reserveType) {
      if (reserveType === 'card') {
        // 课卡预约必须有扣次：0 会被后端当成免费预约，这里直接补成最小 1 次
        Object.assign(this.course, {
          is_show_free: 0,
          decrement_number: this.course.decrement_number || 1,
        });
        return;
      }

      if (reserveType === 'free') {
        Object.assign(this.course, {
          decrement_number: 0,
          decrement_days: 0,
          is_disable_number: 0,
          is_disable_term: 0,
          is_disable_ticket: 0,
          is_we_chat_pay: 0,
          price: 0,
          term_price: 0,
          is_show_free: 0,
        });
        return;
      }

      // 不鸽费预约：课程免费但要收押金，只允许微信支付（课卡三个禁用开关由后端一并置 1）
      // 押金就是课程价格，接口要求 ≥ 199 元：这里直接补到最低值，避免运营留着 0 提交后被接口拦下
      const price = Number(this.course.price) >= 199 ? this.course.price : 199;
      const termPrice = Number(this.course.term_price) >= 199 && Number(this.course.term_price) <= Number(price)
        ? this.course.term_price
        : price;
      Object.assign(this.course, {
        decrement_number: 0,
        decrement_days: 0,
        is_disable_number: 1,
        is_disable_term: 1,
        is_disable_ticket: 1,
        is_we_chat_pay: 1,
        is_show_free: 1,
        price,
        term_price: termPrice,
      });
    },
    // 免费 / 不鸽费相当于对所有学员免费开放，属于高风险配置：提交前二次确认（顺手带上课程名与时间，方便核对是不是这节课）
    async confirmReserveMode() {
      const { reserve_type: reserveType, price, date, start_time: startTime } = this.course;
      if (reserveType === 'card') return true;

      const courseName = [this.course.style_name, this.course.difficulty_name].filter(Boolean).join(' · ') || '本课程';
      const isFree = reserveType === 'free';
      const message = isFree
        ? `「${courseName}」${date} ${startTime} 起，学员不扣课卡、不用付钱就能报名，保存后立即对学员生效。`
        : `「${courseName}」${date} ${startTime} 起，学员需先支付 ¥ ${price} 押金才能锁座，签到后原路退回，保存后立即对学员生效。`;

      return this.$confirm(message, '高风险配置确认', {
        type: 'warning',
        confirmButtonText: '确认提交',
        cancelButtonText: '返回修改',
      }).then(() => true).catch(() => false);
    },
    handleMediaTypeChange(value) {
      const currentType = this.lastMediaType;
      if (value === currentType) return;

      const hasContent = this.hasMediaContent(currentType);
      if (!hasContent) {
        this.clearOtherMediaData(value);
        this.mediaType = value;
        this.lastMediaType = value;
        return;
      }

      const typeName = this.getMediaTypeName(currentType);
      this.$confirm(`当前已选择${typeName}，切换后保存时将不再保留${typeName}。确定切换？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.clearOtherMediaData(value);
        this.mediaType = value;
        this.lastMediaType = value;
      }).catch(() => {
        this.mediaType = currentType;
      });
    },
    hasMediaContent(type) {
      if (type === 'course_video') return Number(this.course.course_video_id) > 0;
      if (type === 'trailer') return !!(this.course.trailer_video.raw_src || this.course.trailer_video.src);
      return false;
    },
    getMediaTypeName(type) {
      if (type === 'course_video') return '课程介绍视频';
      if (type === 'trailer') return '课程预告片';
      return '封面图';
    },
    clearOtherMediaData(targetType) {
      if (targetType !== 'course_video') {
        this.course.course_video_id = 0;
      }
      if (targetType !== 'trailer') {
        Object.assign(this.course.trailer_video, {
          media_name: '',
          cover: '',
          raw_src: '',
          src: '',
          state: 1,
        });
        this.trailerFile = null;
      }
      if (targetType !== 'cover') {
        this.course.course_cover_id = 0;
      }
    },
    syncMediaType() {
      const { course } = this;
      const mediaList = course.course_media || [];
      const trailerMedia = mediaList.find(m => Number(m.object_type) === courseMediaTypes.trailer.value);
      if (trailerMedia && !course.trailer_video.raw_src && !course.trailer_video.src) {
        Object.assign(course.trailer_video, trailerMedia);
      }
      const trailer = (course.trailer_video && (course.trailer_video.raw_src || course.trailer_video.src))
        ? course.trailer_video
        : trailerMedia;
      if (trailer && (trailer.raw_src || trailer.src)) {
        this.mediaType = 'trailer';
        this.lastMediaType = 'trailer';
        return;
      }
      if (Number(course.course_video_id) > 0) {
        this.mediaType = 'course_video';
        this.lastMediaType = 'course_video';
        return;
      }
      this.mediaType = 'cover';
      this.lastMediaType = 'cover';
    },
    getTimestampByTimeString(timeString) {
      const millisecond = getMilliseconds(timeString);
      if (Number.isInteger(millisecond)) return toSecond(millisecond);
    },
    async show() {
      if (!this.id) return;
      const { isError, data } = await show(this.id);
      if (isError) return;

      if (data.decrement_number) data.decrement_number = toYuan(data.decrement_number);
      if (data.decrement_days) data.decrement_days = toYuan(data.decrement_days);
      // 复制模板走的是这里：price 与 term_price 都是「分」存储，两个都要转「元」，漏一个就会 ×100
      data.price = data.price ? toYuan(data.price) : 200;
      data.term_price = data.term_price ? toYuan(data.term_price) : 200;

      const { course } = this;
      // 只回填接口真实返回的字段：course 里的 trailer_video / classroom_video 是本地素材对象，
      // 接口已改为通过 course_media 下发，若按 course 的键回填会把它们覆盖成 undefined
      Object.keys(data).forEach(key => {
        if (key in course) course[key] = data[key];
      });
      const mediaList = course.course_media || [];
      if (mediaList.length) {
        const trailer = mediaList.find(m => Number(m.object_type) === courseMediaTypes.trailer.value);
        const classroom = mediaList.find(m => Number(m.object_type) === courseMediaTypes.classroom.value);
        if (trailer) Object.assign(course.trailer_video, trailer);
        if (classroom) Object.assign(course.classroom_video, classroom);
      }

      this.syncMediaType();
      this.syncReserveType();
      this.isNotPersonalCourse = course.card_type_id !== cardTypes.personal.value;
    },
    async getTeachers() {
      const { isError, data } = await getTeachers({
        store_id: this.course.store_id,
        is_brief: 1,
      });

      if (isError) {
        this.isLoadingError = true;
        return;
      }

      this.teachers = data;
    },
    getCourseMediaPayload() {
      const courseMedia = [];
      const { trailer_video: trailer, classroom_video: classroom } = this.course;
      const mediaItems = [
        ...(this.activeMediaType === 'trailer' ? [{ type: courseMediaTypes.trailer.value, video: trailer }] : []),
        { type: courseMediaTypes.classroom.value, video: classroom },
      ];
      mediaItems.forEach(({ type, video }) => {
        if (!video || (!video.raw_src && !video.src)) return;
        courseMedia.push({
          object_type: type,
          media_name: video.media_name,
          cover: video.cover,
          raw_src: video.raw_src,
          src: video.src,
          state: video.state || 1,
        });
      });
      return courseMedia;
    },

    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        if (this.activeMediaType === 'course_video' && !this.course.course_video_id) {
          return this.$message.error('请选择课程介绍视频，或切回封面图！');
        }
        if (this.activeMediaType === 'trailer' && !this.course.trailer_video.raw_src && !this.course.trailer_video.src) {
          return this.$message.error('请上传课程预告片，或切回封面图！');
        }

        // 免费 / 不鸽费课程对所有学员免费开放，提交前二次确认（同 voucher-type/Add.vue 的高风险配置确认）
        if (!(await this.confirmReserveMode())) return;

        this.isSaving = true;
        const course = { ...this.course };
        const { date, start_time, end_time, teachers } = course;
        let course_teachers = [];
        let teacher_names = [];

        for (let i = 0; i < teachers.length; i++) {
          let teacher = teachers[i];
          if (!teacher.id) continue;

          let sub_teacher_id = teacher.sub_teacher_id || 0;
          course_teachers.push({
            teacher_id: teacher.id,
            sub_teacher_id,
          });
          const teacherName = sub_teacher_id
            ? ((teacher.subTeacher && teacher.subTeacher.nickname) || '')
            : teacher.nickname;
          if (teacherName) teacher_names.push(teacherName);
        }
        teacher_names = teacher_names.join('、');

        const firstTeacher = course.teachers[0];
        let teacher_avatar = course.teacher_avatar || firstTeacher.avatar || '';
        let is_show_sub = 0;
        if (firstTeacher.sub_teacher_id) {
          is_show_sub = 1;
          teacher_avatar = (firstTeacher.subTeacher && firstTeacher.subTeacher.avatar) || '';
        }

        if (!teacher_avatar) {
          this.isSaving = false;
          return this.$message.error('请选择上传课程封面！');
        }

        if (!course_teachers.length) {
          this.isSaving = false;
          return this.$message.error('请选择课程老师！');
        }

        const start_time_timestamp = this.getTimestampByTimeString(`${date} ${start_time}`);
        const end_time_timestamp = this.getTimestampByTimeString(`${date} ${end_time}`);
        const course_media = this.getCourseMediaPayload();

        const postData = {
          store_id: course.store_id,
          start_time: start_time_timestamp,
          end_time: this.isTomorrowEndTime ? end_time_timestamp + 86400 : end_time_timestamp,
          course_age_id: course.course_age_id,
          course_column_id: course.course_column_id,
          course_style_id: course.course_style_id,
          course_difficulty_id: course.course_difficulty_id,
          card_type_id: course.card_type_id,
          course_cover_id: this.activeMediaType === 'cover' ? course.course_cover_id : 0,
          course_video_id: this.activeMediaType === 'course_video' ? course.course_video_id : 0,
          course_media,
          course_tag_ids: course.course_tag_ids,
          course_tip_id: course.course_tip_id,
          course_whitelist_id: course.course_whitelist_id,
          student_number: course.student_number,
          teacher_names,
          teacher_avatar,
          course_name: `${course.style_name} · ${course.difficulty_name}`,
          decrement_number: toCent(course.decrement_number),
          decrement_days: toCent(course.decrement_days),
          cancel_hour: course.cancel_hour,
          reserve_day: course.reserve_day,
          course_teachers,
          is_advance_reserve: course.is_advance_reserve,
          is_disable_cancel: course.is_disable_cancel,
          is_we_chat_pay: course.is_we_chat_pay,
          price: toCent(course.price),
          term_price: toCent(course.term_price),
          tag_name: course.tag_name,
          tag_img: course.tag_img,
          is_disable_rank: course.is_disable_rank,
          is_disable_term: course.is_disable_term,
          is_disable_queue: course.is_disable_queue,
          is_disable_number: course.is_disable_number,
          is_disable_ticket: course.is_disable_ticket,
          is_need_id: course.is_need_id,
          is_show_free: course.is_show_free,
          is_hide_in_list: course.is_hide_in_list,
          is_staff_share_only: course.is_staff_share_only,
          is_show_sub,
        };
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseList.push();
      });
    },
  },
  mounted() {
    if (!this.isAdministrator) this.course.store_id = this.userStoreId;
    this.show();
    this.getTeachers();
  }
};
</script>

<style src="./add.css" scoped/>
